
const showloader = () => {
    let loading = document.querySelector("#loadingModal");
    if (loading !== null) loading.style.display = "block";
}
const hideLoader = () => {
    let loading = document.querySelector("#loadingModal");
    if (loading !== null) loading.style.display = "none";
}
setTimeout(hideLoader, 20 * 1000);
const AsignarSelect = (select, value) => {
    let options = select.options;
    for (let i = 0; i < options.length; i++) {
        if (options[i].value == value) {
            select.selectedIndex = i;
            break;
        }
    }

}
const formatDateToLocal = (date) => {
    date = new Date(date);
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0');  // Mes de 0 a 11
    let day = String(date.getDate()).padStart(2, '0');
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
const getpoblacioncp = (
    input,
    selectpais,
    selectprov,
    selectpob,
    valuepola = "",
    valuepais = "",
    encode = false
) => {
    selectpob.innerHTML =
        "<option value='' lang='es' selected disabled>No existe población</option>";
    selectprov.innerHTML =
        "<option value='' lang='es' selected disabled>No existe provincia</option>";

    if (
        selectpais.value == null ||
        selectpais.value == -1 ||
        selectpais.value == ""
    )
        return;
    if (input.value.length < 4) return;
    if (valuepais != "") AsignarSelect(selectpais, valuepais);

    var cp = input.value;
    var pais = selectpais.value;

    showloader();
    selectpob.innerHTML =
        "<option value='' lang='es' selected disabled>Seleccionar una población</option>";
    var url = `/util/poblacionescp`;
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ cp: cp.trim(), pais: pais.trim(), encode: (encode) ? 1 : 0 }),
    })
        .then((response) => response.json())
        .then((data) => {
            selectpob.innerHTML = "";
            if (
                data == null ||
                data.data == null ||
                data.data == "" ||
                data.data == undefined ||
                data.code != 200
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "No se han encontrado poblaciones con ese código postal",
                    showConfirmButton: false,
                    timer: 2000

                });

                selectpob.innerHTML =
                    "<option value='' lang='es' selected disabled >No existe población</option>";

                hideLoader();
                return;
            } else {
                if (data.data != null) {
                    data = Object.keys(data.data).map((key) => data.data[key]);
                }
                else {
                    data = [];
                    selectpob.innerHTML =
                        "<option value='' lang='es' selected disabled >No existe población</option>";
                    selectprov.innerHTML =
                        "<option value='' lang='es' selected disabled>No existe provincia</option>";
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "No se han encontrado poblaciones con ese código postal",
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }
            if (data.length > 1) {
                selectpob.innerHTML =
                    "<option value='' lang='es' selected disabled>Seleccionar una población</option>";
            }

            data.forEach((element, i) => {
                if (i == 0) {
                    selectprov.innerHTML = "";
                    var option1 = document.createElement("option");
                    option1.value = element.idprovincia;
                    option1.text = element.provincia;
                    selectprov.appendChild(option1);
                }
                var option = document.createElement("option");
                option.value = element.idpoblacion;
                option.text = element.poblacion;
                selectpob.appendChild(option);
            });
            if (valuepola != "") AsignarSelect(selectpob, valuepola);
            hideLoader();
        });
}
const findParametersPost = (nameclass) => {
    let elements = document.querySelectorAll(`.${nameclass}`);
    let param = {};
    elements.forEach((element) => {
        let name = element.getAttribute('name');
        if (name == null || name == "") {
            name = element.id;
        }
        if (name == null || name == "") {
            return;
        }
        let value = element.value;
        if (value !== "" && value !== null && value !== undefined) {
            // Usamos la sintaxis correcta para crear un objeto dinámico

            param[name.trim()] = value.trim();

        }
    });

    return param;
}
const AddCart = (btn, url) => {
    let id = btn.getAttribute("data-id");
    let cantidad = btn.getAttribute("data-cantidad");
    let param = { id: id, cantidad: cantidad };
    showloader();
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(param),
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.code == 200) {
                Swal.fire({
                    icon: "success",
                    title: "Correcto",
                    text: data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                let carts = document.querySelectorAll(".numcart");
                if (carts != null && carts.length > 0) {
                    carts.forEach((cart) => {
                        cart.innerHTML = data.data.numcart;
                    });
                }
                if (cartToast != null && cartToast != undefined) {
                    cartToast.show();
                }
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        }).catch((error) => {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Error al añadir al carrito",
                showConfirmButton: false,
                timer: 2000

            });
            console.error(error);
        }).finally(() => {
            hideLoader();
        });
}

const determinarTipoElemento = (elemento) => {
    if (!elemento || !elemento.tagName) {
        return 'Elemento no válido';
    }

    const tagName = elemento.tagName.toLowerCase();

    if (tagName === 'input') {
        return elemento.type.toLowerCase();
    } else if (tagName === 'select') {
        return 'select';
    } else if (tagName === 'textarea') {
        return 'textarea';
    } else if (tagName === 'button') {
        return 'button';
    } else if (tagName === 'a') {
        return 'a';
    } else if (tagName === 'div') {
        return 'div';
    } else {
        return tagName || 'Elemento desconocido';
    }
}
const AsignarValueElmento = (elemento, valor) => {
    if ( elemento ===null ||  elemento && elemento.classList !== null && elemento.classList.contains('noasigne')) {
        return;
    }
    let type = determinarTipoElemento(elemento);
    switch (type) {
        case 'text':
        case 'select':
        case 'file':
        case 'hidden':
        case 'email':
        case 'password':
        case 'tel':
        case 'url':
        case 'search':
        case 'date':
        case 'time':
        case 'datetime-local':
        case 'month':
        case 'week':
        case 'color':
        case 'range':
            elemento.value = valor;
            break;
        case 'number':
            elemento.value = parseFloat(valor).toFixed(2);
            //elemento.innerHTML = parseFloat(valor).toFixed(2);
            break;
        case 'checkbox':
        case 'radio':
            if (valor == 1 || valor == true || valor == 'true' || valor == '1' || valor == 'on' || valor == 'yes' || valor == 'si' || valor == 'sí' || valor == 'activo' || valor == 'active' || valor == 'true') {
                elemento.checked = true;
            } else {
                elemento.checked = false;
            }
            elemento.value = valor;
            break;
        case 'textarea':
            elemento.innerHTML = valor;
            elemento.value = valor;
            break;
    }
}
const ObtenerValueElemento = (elemento) => {
    let type = determinarTipoElemento(elemento);
    let valor;

    switch (type) {
        case 'text':
        case 'select':
        case 'file':
        case 'hidden':
        case 'email':
        case 'password':
        case 'tel':
        case 'url':
        case 'search':
        case 'date':
        case 'time':
        case 'datetime-local':
        case 'month':
        case 'week':
        case 'color':
        case 'range':
        case 'number':
            valor = elemento.value;
            break;
        case 'checkbox':
        case 'radio':
            valor = elemento.checked ? elemento.value : null;
            break;
        case 'textarea':
            valor = elemento.value || elemento.innerHTML;
            break;
        default:
            valor = null; // Si el tipo no es manejado, se devuelve null
    }

    return valor;
}
const ConfirmSubmit = (btn, msj, nameclass = "") => {
    let form = btn.closest('form');
    Swal.fire({
        title: '¿Estás seguro?',
        text: msj,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, hazlo!',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            if (nameclass != "") {
                showloader();
                let params = findParametersPost(nameclass);
                if (params != null && params != undefined) {
                    Object.keys(params).forEach((key) => {
                        let inputexist = form.querySelector('[name="' + key + '"]');
                        if (inputexist != null) {
                            inputexist.value = params[key];
                        } else {
                            let input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = key;
                            input.value = params[key];
                            form.appendChild(input);
                        }
                    });
                }
            }
            let iduser = form.id.replace('form', '');
            let inputexistuser = form.querySelector('[name="iduser"]');
            if (inputexistuser != null) {
                inputexistuser.value = iduser;
            } else {

                let input = document.createElement('input');
                input.type = "hidden";
                input.name = "iduser";
                input.value = iduser;
                form.appendChild(input);
            }


            form.submit();

        }
    });

}
const ValidateDateIniFin = (dateini, datefin) => {
    let dateiniValue = dateini.value;
    let datefinValue = datefin.value;
    if (dateiniValue == "" || datefinValue == "") {
        return;
    }
    let dateiniDate = new Date(dateiniValue);
    let datefinDate = new Date(datefinValue);
    if (dateiniDate >= datefinDate) {
        datefin.value = dateiniValue;
        Swal.fire({
            icon: "error",
            title: "Información",
            text: "La fecha de inicio no puede ser mayor o igual a la fecha fin",
            showConfirmButton: false,
            timer: 2000
        });
    }


}
